import type { SearchOption } from './SearchSelect';

/**
 * The form of a farm name that two farms may not share — the server's rule
 * (`common/name-key.ts`), so the form flags exactly what saving would refuse.
 * Case, spacing and punctuation are ignored: "Okara Farm 12", "okara farm12"
 * and "Okara-Farm 12" are one name. Letters in any script count.
 */
export function farmNameKey(name: string): string {
  return name
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]/gu, '');
}

/** Whether two farm names count as the same: see `farmNameKey`. */
export function sameFarmName(a: string, b: string): boolean {
  const key = farmNameKey(a);
  return key !== '' && key === farmNameKey(b);
}

/** The name box's search: every typed word appears in the name, Urdu name,
 *  code or district — or the name holds the typed text once spacing and
 *  punctuation are set aside, so "okara-farm" still finds "Okara Farm 12". */
export function matchFarmName(option: SearchOption, query: string): boolean {
  const haystack = `${option.label} ${option.keywords ?? ''}`.toLowerCase();
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.every((word) => haystack.includes(word))) return true;
  const key = farmNameKey(query);
  return key !== '' && farmNameKey(option.label).includes(key);
}
